<template>
  <div>
    <keep-alive v-if='currentNavigationList.some((nav,index)=>nav.path===$route.path)'>
      <router-view @hook:activated="onComponentActivated"></router-view>
    </keep-alive>
    <router-view v-else></router-view>
  </div>
</template>
<script>
import { mapState,mapGetters } from 'vuex';
export default {
  name: "hall",
  computed:{
    ...mapState({
      navigationList: (state) => state.tabNavigation.navigationList
    }),
    ...mapGetters('tabNavigation',['currentNavigationList'])
  },
  mounted(){
  
  },
  methods:{
	onComponentActivated(component){
	
	}
  }
};
</script>
<style scoped></style>
